import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import BlogPost from './BlogPost';
import RevnuBlogPost, { BlogArticleLoading } from './RevnuBlogPost';
import { findRevnuPost, loadRevnuManifest, normalizeBlogPath } from '../utils/revnuBlog';

// /blog/* — a Revnu post when the build manifest has a route for this exact
// path (/blog + canonicalPath), otherwise the legacy markdown post. Once the
// Revnu agent imports a legacy post at the same path, Revnu's copy wins.
const BlogPostRoute = () => {
  const route = normalizeBlogPath(useLocation().pathname);
  const [resolved, setResolved] = useState(null);

  useEffect(() => {
    let alive = true;
    loadRevnuManifest().then((manifest) => {
      if (alive) setResolved({ route, entry: findRevnuPost(manifest, route) });
    });
    return () => { alive = false; };
  }, [route]);

  if (!resolved || resolved.route !== route) return <BlogArticleLoading />;
  if (resolved.entry) return <RevnuBlogPost entry={resolved.entry} />;
  return <BlogPost slug={route.slice('/blog/'.length)} />;
};

export default BlogPostRoute;
